import { Component } from '@angular/core';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import * as firebase from 'firebase';
import { AuthService } from './auth/auth.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'Salto';

  constructor(public authService: AuthService) {}

  ngOnInit() {
    firebase.initializeApp({
      apiKey: 'AIzaSyBFXRldLw2cqCGRg5E8qcLgoIjIVCEOoCA',
      authDomain: 'salto-25b3e.firebaseapp.com',
      projectId: 'salto-25b3e',
      databaseURL: 'https://salto-25b3e.firebaseio.com'
    });
  }
}



// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/app.component.ts